module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [(_vm.orderResult) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box margin-b20 padding-b10"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Resumo e Confirmação do pedido")]), _vm._v(" "), (_vm.rodosol) ? _c('div', {
    staticClass: "teste bold"
  }, [_c('span', [_vm._v("Saldo remanescente Plano Rodosol")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.contract.currentBalance.currentBalance)))])]) : _vm._e(), _vm._v(" "), (
    _vm.contract &&
    _vm.contract.plan &&
    _vm.contract.plan.name &&
    _vm.order &&
    !(_vm.order.salesType === 'RECHARGE' || _vm.order.type === 'RECHARGE')
  ) ? _c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "info-choose-plan"
  }, [_vm._v("\n            Plano Escolhido: "), _c('b', [_vm._v(_vm._s(_vm.contract.plan.name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [(
    _vm.orderResult.salesType != 'RECHARGE' &&
    (_vm.isCaminhoParana || _vm.order.promotionCode == 'CAMINHOSDOPARANA')
  ) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : (
    _vm.orderResult.salesType != 'RECHARGE' &&
    _vm.orderResult.salesType != 'MIGRATIONPLAN'
  ) ? _c('div', [(!_vm.order.salesOrderId) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("Forma de envio")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.possuiTagReserva ? 'col-md-4' : 'col-md-6'
  }, [_c('div', {
    staticClass: "content-box methods rbox",
    class: {
      active: '1' == _vm.shipmentType
    },
    attrs: {
      "id": "freeBox"
    },
    on: {
      "click": function($event) {
        _vm.shipmentType = '1'
      }
    }
  }, [_c('div', {
    staticClass: "methods-rbox"
  }, [_c('div', {
    staticClass: "radio-blue category"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }],
    staticClass: "radiobtn",
    attrs: {
      "type": "radio",
      "value": "1",
      "id": "free",
      "checked": "",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.shipmentType, "1")
    },
    on: {
      "change": function($event) {
        _vm.shipmentType = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label label-h4",
    attrs: {
      "for": "free"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "check first"
  })])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    class: _vm.possuiTagReserva ? 'col-md-4' : 'col-md-6'
  }, [(_vm.showRetiradaEmMaos) ? _c('div', {
    staticClass: "content-box methods rbox",
    class: {
      active: '3' == _vm.shipmentType
    },
    attrs: {
      "id": "emMaosBox"
    },
    on: {
      "click": function($event) {
        _vm.shipmentType = '3'
      }
    }
  }, [_c('div', {
    staticClass: "methods-rbox"
  }, [_c('div', {
    staticClass: "radio-blue category"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }],
    staticClass: "radiobtn",
    attrs: {
      "type": "radio",
      "value": "3",
      "id": "emMaos",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.shipmentType, "3")
    },
    on: {
      "change": function($event) {
        _vm.shipmentType = "3"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label label-h4",
    attrs: {
      "for": "emMaos"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "check first"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    style: ({
      color: _vm.shipmentType == '3' ? '#FFFFFF' : '#666666',
    })
  }, [_vm._v("\n                          Para retirada do TAG apenas em local autorizado\n                          (Parceiro).\n                        ")])])]) : _vm._e()]), _vm._v(" "), (_vm.possuiTagReserva) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "content-box methods rbox",
    class: {
      active: '4' == _vm.shipmentType
    },
    attrs: {
      "id": "tagEmMaosBox"
    },
    on: {
      "click": function($event) {
        _vm.shipmentType = '4'
      }
    }
  }, [_c('div', {
    staticClass: "methods-rbox"
  }, [_c('div', {
    staticClass: "radio-blue category"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }],
    staticClass: "radiobtn",
    attrs: {
      "type": "radio",
      "value": "4",
      "id": "possuiTagReserva",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.shipmentType, "4")
    },
    on: {
      "change": function($event) {
        _vm.shipmentType = "4"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label label-h4",
    attrs: {
      "for": "possuiTagReserva"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "check first"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    style: ({
      paddingRight: '10px',
      color: _vm.shipmentType == '4' ? '#FFFFFF' : '#666666',
    })
  }, [_vm._v("\n                      TAG já disponível para ativação imediata.\n                      ")])])])]) : _vm._e()]), _vm._v(" "), (
    _vm.shipmentType && _vm.shipmentType != 3 && _vm.shipmentType != 4
  ) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible margin-b10 margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(4), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Prazo de entrega")]), _vm._v(":\n                    "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prazoEntrega)
    }
  })])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('section', [(
    (!_vm.shipmentType || _vm.shipmentType == 1) &&
    !_vm.order.salesOrderId &&
    _vm.orderResult.salesType != 'RECHARGE' &&
    !(
      _vm.isCaminhoParana || _vm.order.promotionCode == 'CAMINHOSDOPARANA'
    )
  ) ? _c('div', {
    staticClass: "margin-t20 sent-address-box"
  }, [_c('div', {
    staticClass: "row",
    on: {
      "click": function($event) {
        _vm.toggle = !_vm.toggle
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b', [_vm._v("Detalhes da entrega")]), _vm._v(" "), _c('i', {
    staticClass: "icon-arrow-major-down",
    class: {
      open: !_vm.toggle
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    class: {
      open: !_vm.toggle
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6",
    class: {
      'col-md-12': '3' == _vm.shipmentType
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group no-margin"
  }, [(_vm.account && _vm.account.person) ? _c('label', {
    staticClass: "col-xs-4 text-right"
  }, [_vm._v("\n                        Nome completo:\n                      ")]) : _c('label', {
    staticClass: "col-xs-4 text-right"
  }, [_vm._v("\n                        Empresa:\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 margin-t2"
  }, [_c('p', {
    staticClass: "no-margin bold"
  }, [_vm._v(_vm._s(_vm.nomePfPj))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group no-margin"
  }, [_c('label', {
    staticClass: "col-xs-4 text-right"
  }, [_vm._v(" E-mail: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('p', {
    staticClass: "no-margin bold"
  }, [_vm._v(_vm._s(_vm.email))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group no-margin"
  }, [_c('label', {
    staticClass: "col-xs-4 text-right",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tel. Celular:\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('p', {
    staticClass: "no-margin bold"
  }, [_vm._v(_vm._s(_vm.cellPhone))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "address-box col-md-12"
  }, [_c('div', {
    staticClass: "address-info"
  }, [_c('p', [_vm._v("\n                            " + _vm._s(_vm.address.address) + ", " + _vm._s(_vm.address.number) + " -\n                            " + _vm._s(_vm.address.neighborhood) + "\n                          ")]), _vm._v(" "), _c('p', [_vm._v("\n                            CEP " + _vm._s(_vm.address.zipCode) + " - " + _vm._s(_vm.address.city) + " -\n                            " + _vm._s(_vm.address.state) + "\n                          ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm bold",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addNewAddress()
      }
    }
  }, [_vm._v("\n                          Alterar Endereço\n                        ")])]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), (
    _vm.shipmentType &&
    (!_vm.isCaminhoParana ||
      _vm.order.promotionCode != 'CAMINHOSDOPARANA')
  ) ? _c('div', [(_vm.shipmentType) ? _c('div', {
    staticClass: "margin-t20"
  }, [_c('b', [_vm._v("Veículo(s)")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    class: {
      open: !_vm.toggle
    }
  }, _vm._l((_vm.listVehicles), function(vehicle, index) {
    return _c('div', {
      key: index,
      staticClass: "vehicle-box"
    }, [_c('div', {
      staticClass: "inline plate-box border-right-gray"
    }, [_c('p', {
      staticClass: "cell-plate info-car"
    }, [_vm._v("\n                            Placa\n                            "), _c('span', [_vm._v(_vm._s(vehicle.plate))])])]), _vm._v(" "), _c('p', {
      staticClass: "inline border-right-gray"
    }, [_vm._v("\n                          Marca "), _c('b', [_vm._v(_vm._s(vehicle.model.brand.name))])]), _vm._v(" "), _c('p', {
      staticClass: "inline"
    }, [_vm._v("\n                          Modelo "), _c('b', [_vm._v(_vm._s(vehicle.model.name))])])])
  }), 0)]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.shipmentType == 3) ? _c('div', {
    staticClass: "margin-t20"
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (
    _vm.shipmentType &&
    (_vm.shipmentType == 3 ||
      _vm.shipmentType == 4 ||
      _vm.isCaminhoParana ||
      _vm.order.promotionCode == 'CAMINHOSDOPARANA')
  ) ? _c('div', {
    staticClass: "margin-t20 paranaway-vehicle",
    class: {
      'tag-in-hand-layout': _vm.shipmentType == 4
    },
    on: {
      "click": function($event) {
        _vm.shipmentType == 4 ? null : (_vm.toggle = !_vm.toggle)
      }
    }
  }, [_c('b', [_vm._v("Veículo(s)")]), _vm._v(" "), (_vm.shipmentType != 4) ? _c('i', {
    staticClass: "icon-arrow-major-down",
    class: {
      open: !_vm.toggle
    }
  }) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    class: {
      open: _vm.shipmentType == 4 || !_vm.toggle
    }
  }, _vm._l((_vm.listVehicles), function(vehicle, index) {
    return _c('div', {
      key: vehicle.vehicleId || vehicle.plate || index,
      staticClass: "vehicle-box"
    }, [_c('div', {
      staticClass: "vehicle-box-info"
    }, [_c('div', {
      staticClass: "inline"
    }, [_c('p', {
      staticClass: "cell-plate info-car"
    }, [_vm._v("\n                        Placa\n                        "), _c('span', [_vm._v(_vm._s(vehicle.plate))])])]), _vm._v(" "), _c('p', {
      staticClass: "inline"
    }, [_vm._v("\n                      Marca "), _c('b', [_vm._v(_vm._s(vehicle.model.brand.name))])]), _vm._v(" "), _c('p', {
      staticClass: "inline"
    }, [_vm._v("\n                      Modelo "), _c('b', [_vm._v(_vm._s(vehicle.model.name))])])]), _vm._v(" "), (_vm.shipmentType == 4 && _vm.tagInHandStates[index]) ? _c('div', {
      staticClass: "vehicle-tag-activation"
    }, [_c('div', {
      staticClass: "tag-input-wrapper",
      class: {
        'has-value':
        _vm.tagInHandStates[index].serialNumber &&
          _vm.tagInHandStates[index].serialNumber.length > 0,
      }
    }, [(
      _vm.tagInHandStates[index].serialNumber &&
      _vm.tagInHandStates[index].serialNumber.length > 0
    ) ? _c('span', {
      staticClass: "tag-input-floating-label"
    }, [_vm._v("\n                        Número da TAG "), _c('span', [_vm._v("*")])]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tagInHandStates[index].serialNumber),
        expression: "tagInHandStates[index].serialNumber"
      }],
      staticClass: "form-control input-tag-inline",
      attrs: {
        "type": "text",
        "id": 'tagSerialNumberInHand-' + index,
        "inputmode": "numeric",
        "pattern": "[0-9]*",
        "placeholder": "Digite o número da TAG",
        "disabled": _vm.tagInHandStates[index].success ||
          _vm.tagInHandStates[index].loading,
        "maxlength": "18",
        "minlength": "8"
      },
      domProps: {
        "value": (_vm.tagInHandStates[index].serialNumber)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.tagInHandStates[index], "serialNumber", $event.target.value)
        }, function($event) {
          return _vm.handleTagSerialNumberInput(index)
        }]
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-tag-activate",
      attrs: {
        "type": "button",
        "disabled": !_vm.canActivateTagInHand(index)
      },
      on: {
        "click": function($event) {
          return _vm.validateTagInHand(vehicle, index)
        }
      }
    }, [(_vm.tagInHandStates[index].loading) ? _c('span', [_vm._v("Validando...")]) : _c('span', [_vm._v("Ativar TAG")])]), _vm._v(" "), (_vm.tagInHandStates[index].error) ? _c('div', {
      staticClass: "tag-error"
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 16 16",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('g', {
      attrs: {
        "clip-path": "url(#clip0_15_906)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
        "fill": "#D32F2F"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M5 5L11 11M11 5L5 11",
        "stroke": "white",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }
    })]), _vm._v(" "), _c('defs', [_c('clipPath', {
      attrs: {
        "id": "clip0_15_906"
      }
    }, [_c('rect', {
      attrs: {
        "width": "16",
        "height": "16",
        "fill": "white"
      }
    })])])]), _vm._v("\n\n                      " + _vm._s(_vm.tagInHandStates[index].error) + "\n                    ")]) : _vm._e()]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (
    _vm.shipmentType != 4 &&
    (_vm.mostrarValores ||
      _vm.isCaminhoParana ||
      _vm.order.promotionCode == 'CAMINHOSDOPARANA' ||
      _vm.orderResult.salesType == 'MIGRATIONPLAN')
  ) ? _c('div', {
    staticClass: "margin-20"
  }, [_c('b', [_vm._v("Valores")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), [(_vm.orderResult && _vm.orderResult.products) ? _c('table', {
    staticClass: "table stripped no-footer desk",
    attrs: {
      "role": "grid"
    }
  }, [_c('tbody', [_vm._l((_vm.orderResult.products), function(product) {
    return [(product.productId != 11) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n                          " + _vm._s(product.productName) + "\n                          "), (_vm.showVehiclesPlates(product)) ? _c('span', [_vm._v("(" + _vm._s(product.quantity) + " veículos)")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(_vm._f("cents")(product.valueTotal)))])])]) : _vm._e()]
  }), _vm._v(" "), (
    _vm.orderResult.salesType == 'ADHESION' ||
    _vm.orderResult.salesType ==
    'ADHESIONVEHICLEADDITIONAL' ||
    _vm.orderResult.salesType ==
    'ADHESIOACONTRACTADDITIONAL'
  ) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("FRETE")]), _vm._v(" "), _c('td', {
    staticClass: "text-right bold"
  }, [_vm._v("GRÁTIS")])]) : _vm._e(), _vm._v(" "), (_vm.orderResult.salesType != 'REPLACETAG') ? _c('tr', [_vm._m(7), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(!_vm.reprocess) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cupom),
      expression: "cupom"
    }],
    staticClass: "inline form-control discount discount-coupon",
    attrs: {
      "minlength": "5",
      "maxlength": "25",
      "type": "text",
      "placeholder": "Digite o código",
      "disabled": _vm.descontoCupom != 0
    },
    domProps: {
      "value": (_vm.cupom)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.cupom = $event.target.value
      }, _vm.handleInputChange]
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.reprocess) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.descontoCupom),
      expression: "!descontoCupom"
    }],
    staticClass: "inline btn btn-primary btn-discount discount-coupon",
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": !_vm.cupom
    },
    on: {
      "click": function($event) {
        return _vm.calculateDiscount()
      }
    }
  }, [_vm._v("\n                          Aplicar Desconto\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.reprocess) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.descontoCupom == 2),
      expression: "descontoCupom == 2"
    }],
    staticClass: "inline btn btn-primary btn-discount discount-coupon",
    staticStyle: {
      "color": "white",
      "background-color": "green"
    },
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": !_vm.cupom
    }
  }, [_vm._v("\n                          Desconto Aplicado\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.reprocess && _vm.descontoCupom != 2) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.descontoCupom),
      expression: "descontoCupom"
    }],
    staticClass: "inline btn btn-danger btn-discount discount-coupon",
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": _vm.disableBf
    },
    on: {
      "click": function($event) {
        return _vm.removeDiscount()
      }
    }
  }, [_vm._v("\n                          Remover Desconto\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.erroCupom && _vm.descontoCupom != 2) ? _c('div', {
    staticClass: "discount-error-msg"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.erroCupom))])]) : _vm._e()]), _vm._v(" "), (_vm.descontoCupom == 2 && _vm.reprocess) ? _c('td', {
    staticClass: "text-right bold"
  }, [_vm._v("\n                        " + _vm._s(_vm.cupom) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.descontoCupom != 2) ? _c('td', {
    staticClass: "text-right bold"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(!_vm.descontoCupom ? "-" : (-1 * _vm.descontoCupom))) + "\n                      ")]) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "bold-600",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("TOTAL")]), _vm._v(" "), (_vm.reprocess) ? _c('td', {
    staticClass: "bold text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.orderResult.price)) + "\n                      ")]) : _c('td', {
    staticClass: "bold text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.totalComDesconto)) + "\n                      ")])])])]) : _vm._e(), _vm._v(" "), (_vm.orderResult && _vm.orderResult.products) ? _c('table', {
    staticClass: "table stripped no-footer mob",
    attrs: {
      "role": "grid"
    }
  }, [(_vm.orderResult && _vm.orderResult.products) ? _c('tbody', [_vm._l((_vm.orderResult.products), function(product) {
    return [(product.productId != 11) ? _c('tr', [_c('td', [_vm._v("\n                          " + _vm._s(product.productName) + "\n                          "), (_vm.showVehiclesPlates(product)) ? _c('span', [_vm._v("(" + _vm._s(product.quantity) + " veículos)")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(_vm._f("cents")(product.valueTotal)))])])]) : _vm._e()]
  }), _vm._v(" "), (
    _vm.orderResult.salesType == 'ADHESION' ||
    _vm.orderResult.salesType ==
    'ADHESIONVEHICLEADDITIONAL' ||
    _vm.orderResult.salesType ==
    'ADHESIOACONTRACTADDITIONAL'
  ) ? _c('tr', [_c('td', [_vm._v("FRETE")]), _vm._v(" "), _c('td', {
    staticClass: "text-right bold"
  }, [_vm._v("GRÁTIS")])]) : _vm._e(), _vm._v(" "), (_vm.orderResult.salesType != 'REPLACETAG') ? _c('tr', [_c('td', [_vm._m(8), _vm._v(" "), (!_vm.reprocess) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cupom),
      expression: "cupom"
    }],
    staticClass: "inline form-control discount discount-coupon text-center",
    attrs: {
      "minlength": "5",
      "maxlength": "25",
      "type": "text",
      "placeholder": "Digite o código",
      "disabled": _vm.descontoCupom != 0
    },
    domProps: {
      "value": (_vm.cupom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cupom = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.reprocess) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.descontoCupom),
      expression: "!descontoCupom"
    }],
    staticClass: "inline btn btn-primary btn-discount discount-coupon",
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": !_vm.cupom
    },
    on: {
      "click": function($event) {
        return _vm.calculateDiscount()
      }
    }
  }, [_vm._v("\n                          Aplicar\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.reprocess) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.descontoCupom),
      expression: "descontoCupom"
    }],
    staticClass: "inline btn btn-danger btn-discount discount-coupon",
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": _vm.disableBf
    },
    on: {
      "click": function($event) {
        return _vm.removeDiscount()
      }
    }
  }, [_vm._v("\n                          Remover\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.erroCupom && _vm.descontoCupom != 2) ? _c('div', {
    staticClass: "discount-error-msg"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.erroCupom))])]) : _vm._e()]), _vm._v(" "), (_vm.descontoCupom == 2 && _vm.reprocess) ? _c('td', {
    staticClass: "text-right bold"
  }, [_vm._v("\n                        " + _vm._s(_vm.cupom) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.descontoCupom != 2) ? _c('td', {
    staticClass: "text-right bold"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(!_vm.descontoCupom ? "-" : (-1 * _vm.descontoCupom))) + "\n                      ")]) : _vm._e()]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "bold-600"
  }, [_vm._v("TOTAL")]), _vm._v(" "), (_vm.reprocess) ? _c('td', {
    staticClass: "bold text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.orderResult.price)) + "\n                      ")]) : _c('td', {
    staticClass: "bold text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("cents")(_vm.totalComDesconto)) + "\n                      ")])])])]) : _vm._e()]], 2) : _vm._e()]), _vm._v(" "), (
    !_vm.cpm.error &&
    _vm.orderResult &&
    !_vm.orderResult.salesOrderId &&
    _vm.orderResult.salesType != 'RECHARGE'
  ) ? _c('div', {
    staticClass: "row"
  }, [(_vm.orderResult.salesType === 'ADHESION' && (_vm.skipPaymentFlow || _vm.cpm.paymentMethod != null)) ? _c('div', {
    staticClass: "col-xs-12 margin-t20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.termsAccepted),
      expression: "termsAccepted"
    }],
    staticClass: "check-terms",
    attrs: {
      "id": "terms",
      "type": "checkbox",
      "name": "terms",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.termsAccepted) ? _vm._i(_vm.termsAccepted, "1") > -1 : (_vm.termsAccepted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.termsAccepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.termsAccepted = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.termsAccepted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.termsAccepted = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-terms",
    attrs: {
      "for": "terms"
    }
  }, [_vm._v("\n                Li e aceito as condições gerais de contratação do serviço\n                apresentadas:\n                "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
      "target": "_blank"
    }
  }, [_vm._v("Termo Move Mais")]), _vm._v(" "), (_vm.orderResult.planId == 62 || _vm.orderResult.planId == 64) ? _c('span', [_vm._v("e")]) : _vm._e()]), _vm._v(" "), (_vm.orderResult.salesType != 'RECHARGE') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.termsAdhesionShowError),
      expression: "termsAdhesionShowError"
    }],
    staticClass: "alert alert-danger alert-terms",
    attrs: {
      "id": "alert-terms",
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "help-block term"
  }, [_vm._v("É necessário ler e concordar com os termos para realizar a\n                  adesão")])]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (
    _vm.showAddress &&
    _vm.order &&
    _vm.order.salesType &&
    _vm.order.salesType != 'RECHARGE'
  ) ? _c('div', {}, [(_vm.address) ? _c('div', {
    staticClass: "row margin-b20 address-resume"
  }, [(
    _vm.isCaminhoParana || _vm.order.promotionCode == 'CAMINHOSDOPARANA'
  ) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("Endereço de retirada da TAG eletrônica")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _vm._m(9)]) : _c('div', {}, [(_vm.orderResult.salesOrderShipment) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.orderResult.salesOrderShipment.shipmentType != 3) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("Endereço de entrega")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "radio-box content-box",
    class: {
      active: _vm.whereToDelivery == 0
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.whereToDelivery),
      expression: "whereToDelivery"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "0",
      "type": "radio",
      "name": "radio-address",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.whereToDelivery, "0")
    },
    on: {
      "change": function($event) {
        _vm.whereToDelivery = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "0"
    }
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n                        " + _vm._s(_vm.addressOrderDelivery.address) + ",\n                        " + _vm._s(_vm.addressOrderDelivery.number) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n                        " + _vm._s(_vm.addressOrderDelivery.neighborhood) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n                        CEP " + _vm._s(_vm.addressOrderDelivery.zipCode) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n                        " + _vm._s(_vm.addressOrderDelivery.city) + " -\n                        " + _vm._s(_vm.addressOrderDelivery.state) + " - Brasil\n                      ")]), _vm._v(" "), (
    _vm.addressOrderDelivery.complement &&
    _vm.addressOrderDelivery.complement.length > 0
  ) ? _c('p', [_vm._v("\n                        Complemento - " + _vm._s(_vm.addressOrderDelivery.complement) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('small', {
    staticClass: "block"
  }, [_vm._v("Obs: Os Tags serão entregues no endereço\n                        informado.")])])])]) : _vm._e()]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderResult.salesOrderShipment &&
    _vm.orderResult.salesOrderShipment.shipmentService == 'PAC' &&
    _vm.orderResult.salesOrderShipment.trackingNumber
  ) ? _c('div', {
    staticClass: "margin-t20 margin-b10"
  }, [(
    !_vm.orderResult.salesOrderShipment.trackingNumber ||
    _vm.orderResult.salesOrderShipment.trackingNumber == 'N/A'
  ) ? _c('div', [_vm._v("\n            O código de rastreio estará disponivel em breve.\n          ")]) : (_vm.orderResult.salesOrderShipment.carrier == 'CORREIOS') ? _c('form', {
    attrs: {
      "method": "GET",
      "action": "https://www.websro.com.br/rastreamento-correios.php?",
      "target": "popup",
      "onsubmit": "window.open('', 'popup', 'width=800,height=400')"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "P_COD_UNI",
      "rows": "1",
      "size": "14",
      "wrap": "VIRTUAL"
    },
    domProps: {
      "value": _vm.orderResult.salesOrderShipment.trackingNumber
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "inline track-order"
  }, [_vm._v("\n              Código de Rastreamento:\n              "), _c('b', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.orderResult.salesOrderShipment.trackingNumber))]), _vm._v("\n              - " + _vm._s(_vm.orderResult.salesOrderShipment.carrier) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit",
      "target": "_blank"
    }
  }, [_vm._v("\n              Rastrear Entrega\n            ")])]) : (_vm.orderResult.salesOrderShipment.carrier == 'JADLOG') ? _c('form', {
    attrs: {
      "method": "POST",
      "action": "https://www.jadlog.com.br/siteDpd/tracking.jad",
      "target": "popup",
      "onsubmit": "window.open('', 'popup', 'width=800,height=400')"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cte"
    },
    domProps: {
      "value": _vm.orderResult.salesOrderShipment.trackingNumber
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lang",
      "value": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "inline track-order"
  }, [_vm._v("\n              Código de Rastreamento:\n              "), _c('b', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.orderResult.salesOrderShipment.trackingNumber))]), _vm._v("\n              - " + _vm._s(_vm.orderResult.salesOrderShipment.carrier) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit",
      "target": "_blank"
    }
  }, [_vm._v("\n              Rastrear Entrega\n            ")])]) : (
    _vm.orderResult.salesOrderShipment.carrier == 'TOTALEXPRESS'
  ) ? _c('form', {
    attrs: {
      "method": "GET",
      "action": "https://tracking.totalexpress.com.br/tracking/0",
      "target": "popup",
      "onsubmit": "window.open('', 'popup', 'width=100%')"
    }
  }, [_c('p', {
    staticClass: "inline track-order"
  }, [_vm._v("\n              Código de Rastreamento:\n              "), _c('b', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.orderResult.salesOrderShipment.trackingNumber))]), _vm._v("\n              - " + _vm._s(_vm.orderResult.salesOrderShipment.carrier) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit",
      "target": "_blank"
    }
  }, [_vm._v("\n              Rastrear Entrega\n            ")])]) : (
    _vm.orderResult.salesOrderShipment.carrier == 'TRANSLEVELOG'
  ) ? _c('form', {
    attrs: {
      "method": "GET",
      "action": "https://todo.com.br",
      "target": "popup",
      "onsubmit": "window.open('', 'popup', 'width=100%')"
    }
  }, [_c('p', {
    staticClass: "inline track-order"
  }, [_vm._v("\n              Código de Rastreamento:\n              "), _c('b', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.orderResult.salesOrderShipment.trackingNumber))]), _vm._v("\n              - " + _vm._s(_vm.orderResult.salesOrderShipment.carrier) + "\n            ")]), _vm._v(" "), (false) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit",
      "target": "_blank"
    }
  }, [_vm._v("\n              Rastrear Entrega\n            ")]) : _vm._e()]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showEntries) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showEntries = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Praças")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('h3', [_vm._v("Praças onde a TAG pode ser retirada")]), _vm._v(" "), _vm._l((_vm.entries), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('p', [_vm._v(_vm._s(item.roadCode) + " KM " + _vm._s(item.km) + " - " + _vm._s(item.city))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showEntries = false
      }
    }
  }, [_vm._v("\n            Fechar\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showVehicle) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block",
      "background": "rgba(230, 230, 230, 0.8)"
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header modal-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showVehicle = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Visualizar Veículos")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "bold-600 text-center"
  }, [_vm._v("Placa dos Veículos:")]), _vm._v(" "), _c('div', {
    staticClass: "cell-plate"
  }, _vm._l((_vm.listVehicles), function(vehicle, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n              " + _vm._s(vehicle.plate) + "\n            ")])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade agreed",
    attrs: {
      "id": "ModalConveniados",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "ModalListaConveniados"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table stripped"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.conveniados), function(v, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(v.cidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.nomeFantasia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.endereco))])])
  }), 0)]), _vm._v(" "), _vm._l((_vm.conveniados), function(v, index) {
    return _c('div', {
      key: index,
      staticClass: "info mob"
    }, [_c('p', {
      staticClass: "inline"
    }, [_vm._v(_vm._s(v.cidade))]), _vm._v(" "), _c('p', {
      staticClass: "inline bold"
    }, [_vm._v(_vm._s(v.nomeFantasia))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(v.endereco))])])
  })], 2), _vm._v(" "), _vm._m(12)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "ModalConveniados2",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "ModalListaConveniados",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [
    [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('title-user', [_vm._v(" Parceiros ")]), _vm._v(" "), _c('h3', {
      staticClass: "bold"
    }, [_vm._v("\n                    Caso não tenha um local próximo a você, altere a forma de\n                    envio.\n                  ")]), _vm._v(" "), _vm._m(14)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      directives: [{
        name: "async",
        rawName: "v-async.opacity",
        value: (_vm.loading),
        expression: "loading",
        modifiers: {
          "opacity": true
        }
      }],
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "form-content"
    }, [_c('div', {
      staticClass: "row"
    }, [(_vm.conveniados) ? _c('table', {
      staticClass: "table no-footer",
      attrs: {
        "role": "grid"
      }
    }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.conveniados), function(v, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(v.cidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.nomeFantasia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.endereco))])])
    }), 0)]) : _vm._e()])])])])])]
  ], 2), _vm._v(" "), _vm._m(16)])])]), _vm._v(" "), (_vm.account || _vm.currentUser) ? _c('div', {
    staticClass: "modal fade purchase-summary",
    attrs: {
      "id": "modalPurchase",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modalPurchaseLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "modal-data-box"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.account && _vm.account.person) ? _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome completo")]) : _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.nomePfPj
    }
  })]), _vm._v(" "), (
    _vm.shipmentType &&
    _vm.shipmentType != 3 &&
    _vm.orderResult.salesType != 'RECHARGE' &&
    !(
      _vm.isCaminhoParana ||
      _vm.order.promotionCode == 'CAMINHOSDOPARANA'
    )
  ) ? _c('div', [_c('div', {
    staticClass: "form-group mob"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.address.address +
        ', ' +
        _vm.address.number +
        ' - ' +
        _vm.address.neighborhood +
        (_vm.address.complement ? ' - ' + _vm.address.complement : '')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row mob"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.address.city + '-' + _vm.address.state
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.address.zipCode
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "info-mob"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.address.address + ', ' + _vm.address.number
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.address.neighborhood
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.address.zipCode
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.address.city + '-' + _vm.address.state
    }
  })])])]) : (_vm.shipmentType == 3) ? _c('div', [_vm._m(19)]) : (
    _vm.orderResult.salesType != 'RECHARGE' &&
    (_vm.isCaminhoParana ||
      _vm.order.promotionCode == 'CAMINHOSDOPARANA')
  ) ? _c('div', {
    staticClass: "info-paranaway"
  }, [_vm._m(20)]) : _vm._e()])]), _vm._v(" "), (!_vm.skipPaymentFlow) ? _c('div', {
    staticClass: "col-md-4 info-purchase"
  }, [_vm._m(21), _vm._v(" "), (_vm.orderResult && _vm.orderResult.products) ? _c('div', {
    staticClass: "modal-info-box"
  }, [_c('p', {
    staticClass: "upper"
  }, [_vm._v("seus valores")]), _vm._v(" "), _vm._l((_vm.orderResult.products), function(product, index) {
    return _c('p', {
      key: index
    }, [(_vm.showVehiclesPlates(product)) ? _c('span', [_vm._v("TAG(s) (" + _vm._s(product.quantity) + ")")]) : _c('span', [_vm._v(_vm._s(product.productName))]), _vm._v(" "), (
      _vm.reprocess &&
      product.productId == 11 &&
      product.valueUnit > 0
    ) ? _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm._f("cents")((-1 * product.valueTotal))))]) : _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(product.valueTotal)))])])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n                  Total da compra\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalComDesconto)))])]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "bold"
  }, [_vm._v("\n                  Total\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalComDesconto)))])])], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.skipPaymentFlow) ? _c('div', {
    staticClass: "margin-b20 desk"
  }, [_vm._m(23), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/Lock.svg",
      "alt": "",
      "height": "11"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.skipPaymentFlow) ? _c('div', {
    staticClass: "row"
  }, [(_vm.cpm && _vm.cpm.number) ? _c('div', {
    staticClass: "col-md-8 cc"
  }, [_c('div', {
    staticClass: "modal-data-box"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número do cartão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.cpm.number
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "credit-card-selection",
    attrs: {
      "src": '/static/payment-methods/' + _vm.cpm.paymentMethod.imagePath
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Títular do cartão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.cpm.ownerName
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mob"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Válido até")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.cpm.expirationMonth + '/' + _vm.cpm.expirationYear
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-data-box mobile"
  }, [_c('div', {
    staticClass: "form-group inline"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número do cartão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.cpm.number
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group inline"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Válido até")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.cpm.expirationMonth + '/' + _vm.cpm.expirationYear
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group inline"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Títular do cartão")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.cpm.ownerName
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "credit-card-selection",
    attrs: {
      "src": '/static/payment-methods/' + _vm.cpm.paymentMethod.imagePath
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.cpm && _vm.cpm.agencyNumber) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "modal-data-box"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Banco")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.cpm.paymentMethod.paymentName
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "credit-card-selection",
    attrs: {
      "src": '/static/payment-methods/' + _vm.cpm.paymentMethod.imagePath
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Agência")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.cpm.agencyNumber
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mob"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CC")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.cpm.accountNumber
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.cpm && _vm.cpm.paymentMethod) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "modal-data-box"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.cpm.paymentMethod.paymentMethodId == 12) ? _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Boleto bancário")]) : _vm._e(), _vm._v(" "), (_vm.cpm.paymentMethod.paymentMethodId == 109) ? _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Utilizar meu saldo para pagamento")]) : _vm._e()])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._m(24), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success end",
    on: {
      "click": function($event) {
        return _vm.endModal('YES')
      }
    }
  }, [_vm._v("\n            Confirmar compra\n            "), _c('i', {
    staticClass: "icon-tick align-icon-right-white"
  })])])])])]) : _vm._e(), _vm._v(" "), _c('modal-address', {
    attrs: {
      "typePurchase": _vm.orderResult.salesType,
      "address": _vm.selectedAddress,
      "user": _vm.nomePfPj
    },
    on: {
      "deliveryAddress": _vm.deliveryAddress,
      "allAddresses": _vm.allAddresses
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("Forma de retirada")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info generic-s",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n                  Para você que fez a escola pelo Caminhos do Paraná, deverá\n                  retirar seu TAG no seguinte local:\n                ")]), _vm._v(" "), _c('p', [_c('strong', {
    staticClass: "block"
  }, [_vm._v("Base de Apoio Operacional da Conecessionária Caminhos do\n                    Paraná.")]), _vm._v(" "), _c('span', {
    staticClass: "block"
  }, [_vm._v("Rodovia 277, Km 249, 700. - Irati-PR")]), _vm._v("\n                  Atendimento: Segunda a Sexta, das 8 as 17h.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('p', {
    staticClass: "bold",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Frete grátis")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bold"
  }, [_vm._v("Retirada em mãos"), _c('span', [_vm._v(": ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bold"
  }, [_vm._v("TAG em mãos"), _c('span', [_vm._v(": ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('em', {
    staticClass: "color-purple"
  }, [_vm._v("\n                          Obs: Os Tags serão entregues no endereço informado.\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b', [_vm._v("Detalhes para retirada")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn-find-partner",
    attrs: {
      "type": "button",
      "name": "button",
      "data-toggle": "modal",
      "data-target": "#ModalConveniados"
    }
  }, [_vm._v("\n                    Encontre um local para sua retirada.\n                    "), _c('i', {
    staticClass: "icon-circle-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                        Cupom de desconto\n                        "), _c('i', {
    staticClass: "icon-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "O cupom de desconto é um código promocional que você pode utilizar para abater uma parte ou a totalidade do valor de uma compra. É só colar um código promocional válido e clicar em aplicar desconto e pronto, você já vai ter o desconto aplicado na sua compra Move Mais!"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._v("\n                          Cupom de desconto\n                          "), _c('i', {
    staticClass: "icon-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "O cupom de desconto é um código promocional que você pode utilizar para abater uma parte ou a totalidade do valor de uma compra. É só colar um código promocional válido e clicar em aplicar desconto e pronto, você já vai ter o desconto aplicado na sua compra Move Mais!"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-box"
  }, [_c('p', [_vm._v("\n                  Base de apoio operacional da Concessionária Caminhos do\n                  Paraná\n                ")]), _vm._v(" "), _c('p', [_vm._v("Rodovia 277, Km 249, 700")]), _vm._v(" "), _c('p', [_vm._v("Irati - PR")]), _vm._v(" "), _c('p', [_vm._v("Atendimento: Segunda a Sexta, das 8 às 17h.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title upper",
    attrs: {
      "id": "ModalListaConveniados"
    }
  }, [_vm._v("\n            pontos de retirada\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("Local de retirada")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Endereço")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Fechar"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "rule-color",
    attrs: {
      "src": require("../../../static/email/signature/rule_color.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Cidade")]), _vm._v(" "), _c('th', [_vm._v("Parceiro")]), _vm._v(" "), _c('th', [_vm._v("Endereço")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Fechar\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title upper",
    attrs: {
      "id": "modalPurchaseLabel"
    }
  }, [_vm._v("\n            Resumo da compra\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "upper margin-b20"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("1")]), _vm._v(" dados pessoais\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alert alert-info margin-b10",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                    Você escolheu pela \""), _c('b', [_vm._v("Retirada em mãos")]), _vm._v("\". Seu TAG\n                    poderá ser retirado em qualquer um de nossos parceiros.\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alert alert-info margin-b10",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                    Para você que fez a escolha pelo Caminhos do Paraná,\n                    deverá retirar seu TAG no seguinte local:\n                    "), _c('b', {
    staticClass: "margin-t5 block"
  }, [_vm._v("Base de Apoio Operacional da Concessionária Caminhos do\n                      Paraná.")]), _vm._v(" "), _c('span', {
    staticClass: "block"
  }, [_vm._v("Rodovia 277, Km 249, 700 - Irati-PR")]), _vm._v(" "), _c('span', {
    staticClass: "block"
  }, [_vm._v("Atendimento: Segunda a Sexta, das 8 às 17h.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-b20 mob"
  }, [_c('p', {
    staticClass: "upper inline"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("2")]), _vm._v(" detalhes do pagamento\n                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/Lock.svg",
      "alt": "",
      "height": "11"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  Frete\n                  "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("GRÁTIS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "upper inline"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("2")]), _vm._v(" detalhes do pagamento\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n            Voltar\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-280f5c75!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/generic-summary.vue
// module id = 2076
// module chunks = 1